import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { NmiConfig } from '../nmi.config';
import { PaymentMethod, SavePaymentMethodRequest } from '../models/nmi.models';

export class NmiPaymentMethodService {
  private readonly base: string;

  constructor(private http: HttpClient, config: NmiConfig) {
    this.base = config.apiUrl.replace(/\/$/, '');
  }

  save(req: SavePaymentMethodRequest): Observable<PaymentMethod> {
    return this.http.post<PaymentMethod>(`${this.base}/api/payment-methods`, req);
  }

  getByCustomer(customerId: string): Observable<PaymentMethod[]> {
    return this.http.get<PaymentMethod[]>(`${this.base}/api/payment-methods/customer/${customerId}`);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/api/payment-methods/${id}`);
  }
}
